/**
 * Tracks the currently loaded media and its language/subtitle state.
 *
 * - `audios` and `subtitles` map trackId → language code (RFC 5646).
 * - `hasForcedSubtitles` / `forcedSubtitle` handle the "pt" forced track.
 */
export interface ForcedSubtitle {
  trackId: number;
  lang: string;
  label: string;
}

export interface CastMedia {
  contentId: string;
  mediaId: string;
  title: string;
  subtitle: string;
  playlistType: string;
  hasForcedSubtitles: boolean;
  forcedSubtitle: ForcedSubtitle | null;
  audios: Map<number, string>;
  subtitles: Map<number, string>;
}

export function createDefaultMedia(): CastMedia {
  return {
    contentId: '',
    mediaId: '',
    title: '',
    subtitle: '',
    playlistType: '',
    hasForcedSubtitles: false,
    forcedSubtitle: null,
    audios: new Map(),
    subtitles: new Map(),
  };
}
